module.exports = __webpack_public_path__ + "img/bellxecll_logo_profile.29c9fb10.svg";